import { ContentType } from '@ocp-zmarta/content-lib'
import { PAGE_TEMPLATES } from '../constants/content'

const customData = Object.freeze({
  allowedPath: Object.freeze(['content']),
  allowedRefPath: Object.freeze(['content.sections', 'content.hero'])
})

const skipFormattingFields = Object.freeze(['highlightedPartners'])

const pageTypesMapping = {
  [ContentType.GlossaryPage]: PAGE_TEMPLATES.GLOSSARY_PAGE,
  [ContentType.OtherLandingPage]: PAGE_TEMPLATES.LANDING_PAGE,
  [ContentType.PartnerPage]: PAGE_TEMPLATES.PARTNER_PAGE,
  [ContentType.PartnerListPage]: PAGE_TEMPLATES.PARTNER_LIST_PAGE,
  [ContentType.ProductLandingPage]: PAGE_TEMPLATES.LANDING_PAGE
}

export {
  customData,
  pageTypesMapping,
  skipFormattingFields
}
